import { Component, Input, SimpleChanges } from '@angular/core';
import {
  ControlContainer,
  FormControl,
  FormGroup,
  FormGroupDirective,
  Validators,
} from '@angular/forms';
import { HttpService } from 'src/app/core/services/http.service';

@Component({
  selector: 'app-payout-company',
  templateUrl: './payout-company.component.html',
  styleUrls: ['./payout-company.component.scss'],
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective },
  ],
})
export class PayoutCompanyComponent {
  @Input('required') isRequired = false;
  @Input('allRuleIdData') allRuleIdData: any;
  payoutCompanyList: any = [];
  listOfPayoutCompany: any = [];
  form: FormGroup;

  constructor(
    private ctrlContainer: FormGroupDirective,
    private http: HttpService
  ) {}

  ngOnInit() {
    this.form = this.ctrlContainer.form;

    if (this.isRequired) {
      this.form.addControl(
        'payoutCompany',
        new FormControl(null, Validators.required)
      );
    } else {
      this.form.addControl('payoutCompany', new FormControl());
    }
    this.getPayoutCompanyList();
  }

  getPayoutCompanyList() {
    const url = `services/api/v1/company`;
    this.payoutCompanyList = [];
    this.listOfPayoutCompany = [];
    this.http.get(url).subscribe((res: any) => {
      if (res) {
        this.listOfPayoutCompany = res.data;
        for (let i = 0; i <= this.listOfPayoutCompany.length - 1; i++) {
          if (this.listOfPayoutCompany[i].is_active) {
            this.payoutCompanyList.push(this.listOfPayoutCompany[i]);
          }
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes['allRuleIdData']) {
    //   if (changes['allRuleIdData'].currentValue.length !== 0) {
    //     if (
    //       changes['allRuleIdData'].currentValue.company_details[0]
    //         .company_name !== undefined
    //     ) {
    //       let getUrl = window.location.href;
    //       if (getUrl.includes('payout-processing/main/edit-payout-rule')) {
    //         let payoutCompany =
    //           changes['allRuleIdData'].currentValue.company_details[0]
    //             .company_name;
    //         this.form.patchValue({
    //           payoutCompany: payoutCompany,
    //         });
    //       }
    //     }
    //   }
    // }
  }
  ngOnDestroy(): void {
    this.form.removeControl('payoutCompany');
  }
}
